<template lang="pug">
  span.product-info__price {{ price | money }}
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'ProductPrice',
    computed: {
      ...mapState({
        price: state => {
          return state.productPage.price;
        },
      }),
    },
  };
</script>
